<template>
    <div class="field" style="padding-right: 5px;">
        <a class="button is-warning  is-small"
           v-bind:class="{ 'is-loading': isLoading }"
           @click.prevent="deleteFromFavorites()">
            <span>
                <i class="fas fa-minus"></i>
            </span>
            Favorite
        </a>
    </div>
</template>

<script>
    import apiFavorites from '../../../../api/apiFavorites'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                currentFavorite: {
                    lot_id: this.bid.lot_id
                }
            }
        },
        methods: {
            deleteFromFavorites() {
                this.isLoading = true
                apiFavorites
                    .deleteFavoritesRequest(this.currentFavorite)
                    .then((response) => {
                        this.isLoading = false
                        this.bid.favorite = {}

                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            }
        }
    }

</script>

<style scoped>
    .button {
        font-weight: 700;
    }
    .button i {
        margin-right: 0.3em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/FavoriteDelete.vue